import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CropService } from '@next/arable-lib/crop';
import { LocaleService } from '@next/core-lib/i18n';
import { Subject, catchError, map, of, startWith, switchMap } from 'rxjs';

export type MainCropOptionsState =
  | { status: 'loading' }
  | { status: 'failed' }
  | { status: 'loaded'; crops: { id: number; name: string }[] };

@Injectable()
export class GreenManureCropsService {
  private readonly cropService = inject(CropService);
  private readonly locale = inject(LocaleService).getLocale();
  private readonly reload = new Subject<void>();

  readonly state = toSignal(
    this.reload.pipe(
      startWith(undefined),
      switchMap(() =>
        this.cropService.getCrops().pipe(
          map(
            (crops): MainCropOptionsState => ({
              status: 'loaded',
              crops: crops
                .filter((crop) => crop.isGreenManure === false && crop.agrifirmCrop.id !== 1015)
                .map((crop) => ({ id: crop.id, name: crop.agrifirmCrop.name }))
                .sort((a, b) => a.name.localeCompare(b.name, this.locale)),
            }),
          ),
          catchError(() => of<MainCropOptionsState>({ status: 'failed' })),
          startWith<MainCropOptionsState>({ status: 'loading' }),
        ),
      ),
    ),
    { requireSync: true },
  );

  retry(): void {
    this.reload.next();
  }
}
